import React from 'react';
import PropTypes from 'prop-types';


import {listConstants} from '../../contexts/List';

import styles from './PaginationStatus.scss';
import {I18nMessage} from '../../contexts/I18n';


function PaginationStatus({currentElements, page, pageSize, totalElements, totalPages}) {

    const elementsPageStartIndex = (page * pageSize);

    return (
        <div className={styles.paginationStatus}>
            <p>
                <I18nMessage
                    id={'pagination.status.itemsInfo'}
                    values={
                        {
                            elementsPageEnd: elementsPageStartIndex + currentElements,
                            elementsPageStart: elementsPageStartIndex + 1,
                            totalElements
                        }
                    }
                />
                <br/>
                <I18nMessage
                    id={'pagination.status.pageInfo'}
                    values={
                        {
                            page: page + 1,
                            totalPages
                        }
                    }
                />
            </p>
        </div>
    );
}


PaginationStatus.propTypes = {
    ...listConstants.SHAPE_LIST_ROOT
};

PaginationStatus.defaultProps = {};


export default PaginationStatus;
